import type { PageObjectModel } from '@sosocio/creator-types/project';

const CIRCLE_MASK_SOURCE = `data:image/svg+xml,${encodeURIComponent('<svg xmlns="http://www.w3.org/2000/svg" width="1000" height="1000" viewBox="0 0 1000 1000" preserveAspectRatio="none"><circle cx="500" cy="500" r="500"/></svg>')}`;

/**
 * Resolves the shared source for a built-in page-object mask identifier.
 *
 * The renderer hosts use the same mask artwork so Creator, kiosk previews,
 * and print rendering cannot drift at the shape boundary.
 *
 * @param mask Canonical page-object mask identifier.
 * @returns Built-in mask source, or `null` when the identifier is host-owned.
 */
export function resolvePageObjectMaskSource(
	mask: PageObjectModel['mask'],
): string | null {
	if (
		mask === 'circle'
		|| mask === 'circleLocked'
	) {
		return CIRCLE_MASK_SOURCE;
	}

	return null;
}
